// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__h8UFT","logo":"navbar_logo__Q3iz5","add":"navbar_add__yI-aT"};